import React from "react";
import "./logobar.css";

function Logobar() {
  return (
    <div className="logobar">
      {/* <img src="/images/logos.png" alt="Muhurtmedh Logo" className="logo" /> */}
      <h2>MUHURTMEDH</h2>
    </div>
  );
}

export default Logobar;
